/** @format */

import Layout from '../Partials/Layout';
import { Spinner } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import api from '../../shared/utils/auth/Index';
import { useAlert } from 'react-alert';
import Loader from '../../shared/components/Loader';
import { redirect } from '../../shared/utils/helpers';
import { useHistory, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare, faTimes } from '@fortawesome/free-solid-svg-icons';
import Images from './Partials/Images';
import Attributes from './Partials/Attributes';

const Form = () => {
	let { id } = useParams();
	const history = useHistory();

	const isItUpdate = () => {
		return id !== undefined;
	};

	let reactAlert = useAlert(null);

	const [formData, setFormData] = useState({
		images: [],
		product_attributes: [],
	});

	const [sending, setSending] = useState(false);
	const onSubmit = (e) => {
		e.preventDefault();

		setSending(true);
		submit();
	};

	const submit = () => {
		let url = isItUpdate() ? `/products/${id}` : '/products';

		api.post(
			url,
			{
				...formData,
				images: JSON.stringify(formData.images),
				product_attributes: JSON.stringify(formData.product_attributes),
			},
			(res) => {
				reactAlert.success('اطلاعات ذخیره شد.');
				setSending(false);
				history.push('/products');
			},
			(err) => {
				alert('error');
				console.log(err);
				setSending(false);
			},
		);
	};

	useEffect(() => {
		if (id) {
			fetchProduct();
		}
	}, []);

	const fetchProduct = () => {
		let url = `/products/${id}`;
		api.get(
			url,
			{},
			(res) => {
				let data = res.data.data;
				setFormData(data);
			},
			(err) => {
				alert('error');
			},
		);
	};

	if (isItUpdate() && formData.id === undefined)
		return (
			<Layout>
				<Loader />
			</Layout>
		);

	return (
		<Layout>
			<form onSubmit={(e) => onSubmit(e)}>
				<div className='row'>
					<div className='col-md-6'>
						<div className='form-group'>
							<label htmlFor='exampleInputEmail1' className='font-irs-b'>
								نام
							</label>
							<input
								type='text'
								className='form-control'
								required
								value={formData.name}
								onChange={(e) =>
									setFormData({ ...formData, name: e.target.value })
								}
							/>
						</div>
					</div>
					<div className='col-md-3'>
						<div className='form-group'>
							<label htmlFor='exampleInputEmail1' className='font-irs-b'>
								قیمت
							</label>
							<input
								type='number'
								className='form-control'
								value={formData.default_price}
								onChange={(e) =>
									setFormData({ ...formData, default_price: e.target.value })
								}
							/>
						</div>
					</div>
					<div className='col-md-3'>
						<div className='form-group'>
							<label htmlFor='exampleInputEmail1' className='font-irs-b'>
								تعداد
							</label>
							<input
								type='number'
								className='form-control'
								value={formData.default_capacity}
								onChange={(e) =>
									setFormData({ ...formData, default_capacity: e.target.value })
								}
							/>
						</div>
					</div>
				</div>
				<hr />
				<Images formData={formData} setFormData={setFormData} />
				<hr />
				<Attributes formData={formData} setFormData={setFormData} />
				<hr />
				<div className='row'>
					<div className='col-12'>
						<div className='form-group'>
							<div className='form-group'>
								<label htmlFor='exampleInputEmail1' className='font-irs-b'>
									توضیحات
								</label>
								<textarea
									className='form-control'
									value={formData.description}
									onChange={(e) =>
										setFormData({ ...formData, description: e.target.value })
									}
									required
								/>
							</div>
						</div>
					</div>
				</div>

				<div className='row mt-5'>
					<div className='col-auto mr-auto'>
						<button className='btn btn-primary' type='submit'>
							ذخیره
							{sending && <Spinner animation={'border'} />}
						</button>
					</div>
				</div>
			</form>
		</Layout>
	);
};
export default Form;
